module.exports = __webpack_public_path__ + "img/img1.f7de365.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/05/img1.png
// module id = 54
// module chunks = 0